import * as React from 'react';
import UserLink from '../../../../links/UserLink';
import { BettingUser, TournamentRoundGroupMember } from '../../../../services/betting';

/*
 * Copyright (c) Funtip GbR 2017.
 * Simon Oldeboershuis, Perry Prust
 */

interface NodeGridRowProps {
    trgm?: TournamentRoundGroupMember;
    user?: BettingUser;
    tournamentRoundGroupMembers?: TournamentRoundGroupMember[];
    startColumn: number;
    columnCount: number;
}

export const NodeGridRow: React.FC<NodeGridRowProps> = (props) => {
    if (props.trgm && props.tournamentRoundGroupMembers && props.user !== undefined) {
        return (
            <tr>
                <td className="ps-0 pe-1 p-sm-3 align-middle">
                    {props.trgm.rank}
                    <br />
                    <small className="text-sm-center">({props.trgm.absoluteRank})</small>
                </td>
                <td className="ps-0 pe-0 d-sm-none border-right  align-middle">
                    <UserLink id={String(props.user.id)} name={props.user.name} maxWidth={70} />
                </td>
                <td className="ps-0 pe-0 d-none d-sm-table-cell border-right align-middle">
                    <UserLink id={String(props.user.id)} name={props.user.name} maxWidth={130} />
                </td>
                {props.tournamentRoundGroupMembers.map((trgm, index) => {
                    if (index >= props.startColumn && index < props.startColumn + props.columnCount) {
                        return trgm && trgm.points > 0 ? (
                            <td key={index} className="border-right me-1 text-center ps-0 pe-0">
                                <span className="btn-r1--points">{trgm ? trgm.points : ''}</span>
                            </td>
                        ) : (
                            <td key={index} className="border-right me-1 text-center ps-0 pe-0"></td>
                        );
                    }
                    return null;
                })}
                <td>
                    <span className="btn-r1--points">{props.trgm.points}</span>
                </td>
            </tr>
        );
    } else {
        return <tr />;
    }
};
